export default "/dist/files/quiz.0fd9f8b1867899dda5f35ddbf12ef268.svg";